<template>
  <the-modal v-model="show">
    <div class="callback">
      <iframe
        id="calenso"
        name="calenso-widget"
        :src="src"
        referrerpolicy="strict-origin"
        sandbox="allow-scripts allow-same-origin allow-storage-access-by-user-activation"
      />
    </div>
  </the-modal>
</template>

<script>
import { events$ } from '@/services'

import { EVENT_APPOINTMENT_MODAL_OPEN } from '@/config/events'

export default {
  name: 'AppointmentModal',

  data() {
    return {
      show: false,
      src: '',
    }
  },

  created() {
    events$.on(EVENT_APPOINTMENT_MODAL_OPEN, this.open)
  },

  beforeUnmount() {
    events$.off(EVENT_APPOINTMENT_MODAL_OPEN, this.open)
  },

  methods: {
    open(param) {
      this.src = this.$t(`application.sanitas.calenso.${param}`)
      this.show = true
    },
  },
}
</script>

<style name="mobile" scoped>
.callback {
  padding: 50px 0 0 0;
}

#calenso {
  min-height: 500px;
  height: 100%;
  width: 100%;
  border: none;
}
</style>
